import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions
    } = config;
    this.trigger = accordions;

    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;

    if (this.accordions && this.accordions.length !== 0) {
      this.bindEvents();

      const url = location.href;
      const id = url.split('#');

      if (!!id[1]) {
        const accordionToClick = document.querySelector(`#${id[1]} + .ns-accordion`);
        const accordionToScroll = document.querySelector('#' + id[1]);
        const headerOffset = (document.querySelector('.header').offsetHeight - 62) * -1;
        const elementPosition = accordionToScroll.offsetTop;
        const offsetPosition = elementPosition + headerOffset;
        if (accordionToClick) {
          const accordeonHeader = accordionToScroll.querySelector('.ns-accordion__head');
          const accordeonHeaderHeight = accordeonHeader.offsetHeight;
          setTimeout(() => {
            accordeonHeader.click();
            window.scrollTo({
              top: (offsetPosition + accordeonHeaderHeight),
              behavior: "smooth"
            });
          }, 1000);
        } else {
          setTimeout(() => {
            window.scrollTo({
              top: (offsetPosition + 67),
              behavior: "smooth"
            });
          }, 1000);
        }
      }
    }
  }

  bindEvents() {


    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        let parentElement = el.parentNode;
        let siblingElement = el.nextElementSibling;

        Helper.slideToggle(siblingElement);
        if (parentElement.classList.contains('open')) {
          parentElement.classList.remove('open');
        } else {
          parentElement.classList.add('open');
        }
      });
    });
  }
}

export default Accordion;
